import { type UseQueryResult, useQuery } from 'react-query';
import {
  AdvisorApiCredentialService,
  type Wealthlane_Dtos_AdvisorApi_AdvisorApiCredentialDto,
} from '@wealthlane/api-services/wealthlane-identity-service';

const useGetAdvisorApiCredentialList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  companyId?: string,
  enabled = true,
): UseQueryResult<Wealthlane_Dtos_AdvisorApi_AdvisorApiCredentialDto[] | undefined, unknown> => {
  return useQuery(
    ['getAdvisorApiCredentialList', companyId ?? 'self'],
    async () => {
      return await handleRequest(
        AdvisorApiCredentialService.getApiIdentityApiAppAdvisorApiCredential(companyId),
      );
    },
    {
      enabled,
    },
  );
};

export default useGetAdvisorApiCredentialList;
